export enum OperationEnum {
  OnRamp = "ON_RAMP",
  OffRamp = "OFF_RAMP",
}
